// extracted by mini-css-extract-plugin
export default {"arrowIcon":"aT5t2S","arrowIconOpened":"bT5t2S"};